import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/App'
import auth from './modules/Auth'
import user from './modules/User'
import shop from './modules/Shop'
import product from './modules/Product'
import inventory from './modules/Inventory'
import lot from './modules/Lot'
import serial from './modules/Serial'
import partner from './modules/Partner'
import employee from './modules/Employee'
import posBranch from './modules/PosBranch'
import pos from './modules/Pos'
import accounting from './modules/Accounting'
import posbill from './modules/PosBill'
import possession from './modules/PosSession'
import purchase from './modules/Purchase'
import sale from './modules/Sale'
import invoice from './modules/Invoice'
import receipt from './modules/Receipt'
import expense from './modules/Expense'
import payment from './modules/Payment'
import file from './modules/File'
import report from './modules/Report'
import hrm from './modules/Hrm'
import payroll from './modules/Payroll'
import channelauthen from './modules/ChannelAuthen'
import channelnoti from './modules/ChannelNoti'
import logerrorapi from './modules/LogErrorApi'
import logerrorfront from './modules/LogErrorFront'
import analytic from './modules/Analytic'
import appPermission from './modules/AppPermission'
import rolePermission from './modules/RolePermission'
import billing from './modules/Billing'
import treesoft from './modules/TreeSoft'
import document from './modules/Document'
import posQRCode from './modules/PosQRCode'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    auth,
    user,
    shop,
    product,
    inventory,
    lot,
    serial,
    partner,
    employee,
    posBranch,
    pos,
    posbill,
    possession,
    posQRCode,
    accounting,
    purchase,
    sale,
    invoice,
    receipt,
    expense,
    payment,
    file,
    report,
    hrm,
    payroll,
    channelauthen,
    channelnoti,
    logerrorapi,
    logerrorfront,
    analytic,
    appPermission,
    rolePermission,
    billing,
    treesoft,
    document,
  },
  strict: true,
})



// WEBPACK FOOTER //
// ./src/store/index.js